export default {
  allOrders: {
    id: 'sourcing_page_all_orders',
    defaultMessage: 'All orders',
  },
  allOrdersHelp: {
    id: 'sourcing_page_all_orders_help',
    defaultMessage:
      'Display all your orders. You can also search for a specific one.',
  },
  dismissHelpModal: {
    id: 'sav_platform_dismiss_help_modal',
    defaultMessage: 'Thanks for the heads up!',
  },
  helpButtonLabel: {
    id: 'sav_platform_how_does_this_page_work',
    defaultMessage: 'How does this page work?',
  },
  myBuybackOrders: {
    id: 'sav_platform_my_buyback_orders',
    defaultMessage: 'My Buyback orders',
  },
  newOrders: {
    id: 'sourcing_page_new_orders',
    defaultMessage: 'New orders',
  },
  newOrdersHelp: {
    id: 'sourcing_page_new_orders_help',
    defaultMessage:
      'Display the last orders created for you. They are sorted by priority order, regarding the processing delay mentioned in the charter. You must process these orders under 2 working days after the reception. We consider the order processed if it has:',
  },
  newOrdersHelpCounterOffer: {
    id: 'sourcing_page_new_orders_help_counter_offer',
    defaultMessage: 'You have made a counter-offer.',
  },
  newOrdersHelpPaidCustomer: {
    id: 'sourcing_page_new_orders_help_paid_customer',
    defaultMessage: 'The customer has been paid.',
  },
  newOrdersHelpPendingOrder: {
    id: 'sourcing_page_new_orders_help_pending_order',
    defaultMessage: 'You have set the order as pending.',
  },
  pageDescription: {
    id: 'sourcing_page_description',
    defaultMessage: 'Sourcing | Back Market',
  },
  pageTitle: {
    id: 'sourcing_page_title',
    defaultMessage: 'Sourcing',
  },
  pendingCustomers: {
    id: 'sourcing_page_pending_customers',
    defaultMessage: 'Pending customers',
  },
  pendingCustomersHelp: {
    id: 'sourcing_page_pending_customers_help',
    defaultMessage:
      'Display the orders where the customer is waiting for you to answer back. They are sorted by message lifespan. You always must answer a customer message, even if it does not specificaly ask for it.',
  },
  title: {
    id: 'sourcing_page_header_title',
    defaultMessage: 'Buyback orders',
  },
  pageSplitIntoTabs: {
    id: 'sourcing_page_page_split_into_tabs',
    defaultMessage: `The current page is split into {count, plural,
      one {# tab}
      other {# tabs}
    }.`,
  },
}
